import { Auth } from "aws-amplify";

const getJwt = async () => {
  try {
    const user = await Auth.currentAuthenticatedUser();

    return user.signInUserSession.idToken.jwtToken;
  } catch (e) {
    return undefined;
  }
};

export default getJwt;
